import { IMat4, Mat4 } from "./Mat4";
import { IQuat, Quat } from "./Quat";
import { IVec3, Vec3 } from "./Vec3";

export interface ITransformData {
  position: IVec3;
  rotation: IQuat;
  scale: IVec3;
}
export class TransformData {
  static create(pos: IVec3 = Vec3.ZERO, rotation: IQuat = Quat.create()): ITransformData {
    return {
      position: pos,
      rotation: rotation,
      scale: Vec3.ONE
    }
  }

  static toMatrix(transform: ITransformData): IMat4 {
    return Mat4.createTransform({ translation: transform.position, rotation: transform.rotation, scale: transform.scale })
  }
}